import apiClient from 'api/config/apiClient'

export default {
  getBenefitEligibility(payload) {
    return apiClient.request('benefit_elegibility', payload)
  },
}
